import React from 'react';

import Icon, { Props } from './icon';
export const CloseFullscreenIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40" fill="none">
      <path
        d="M14.5834 23.75C15.0254 23.75 15.4492 23.9258 15.7618 24.2383C16.0743 24.5509 16.25 24.9747 16.25 25.4167V33.75C16.25 34.6705 15.5038 35.4167 14.5834 35.4167C13.6629 35.4167 12.9167 34.6705 12.9167 33.75V29.4401L6.17843 36.1784C5.52755 36.8293 4.47253 36.8293 3.82166 36.1784C3.17078 35.5275 3.17078 34.4725 3.82166 33.8217L10.5599 27.0834H6.25004C5.32957 27.0834 4.58337 26.3372 4.58337 25.4167C4.58337 24.4962 5.32957 23.75 6.25004 23.75H14.5834Z"
        fill="#F2F2F2"
      />
      <path
        d="M35 23.3334C35.9205 23.3334 36.6667 24.0796 36.6667 25V35C36.6667 35.9205 35.9205 36.6667 35 36.6667H25C24.0796 36.6667 23.3334 35.9205 23.3334 35C23.3334 34.0796 24.0796 33.3334 25 33.3334H33.3334V25C33.3334 24.0796 34.0796 23.3334 35 23.3334Z"
        fill="#F2F2F2"
      />
      <path
        d="M15 3.33337C15.9205 3.33337 16.6667 4.07957 16.6667 5.00004C16.6667 5.92052 15.9205 6.66671 15 6.66671H6.66671V15C6.66671 15.9205 5.92052 16.6667 5.00004 16.6667C4.07957 16.6667 3.33337 15.9205 3.33337 15V5.00004C3.33337 4.55801 3.50909 4.13422 3.82166 3.82166C4.13422 3.50909 4.55801 3.33337 5.00004 3.33337H15Z"
        fill="#F2F2F2"
      />
      <path
        d="M33.8217 3.82166C34.4725 3.17078 35.5275 3.17078 36.1784 3.82166C36.8293 4.47253 36.8293 5.52755 36.1784 6.17843L29.4401 12.9167H33.75C34.6705 12.9167 35.4167 13.6629 35.4167 14.5834C35.4167 15.5038 34.6705 16.25 33.75 16.25H25.4167C24.9747 16.25 24.5509 16.0743 24.2383 15.7618C23.9258 15.4492 23.75 15.0254 23.75 14.5834V6.25004C23.75 5.32957 24.4962 4.58337 25.4167 4.58337C26.3372 4.58337 27.0834 5.32957 27.0834 6.25004V10.5599L33.8217 3.82166Z"
        fill="#F2F2F2"
      />
    </Icon>
  );
};

export default React.memo(CloseFullscreenIcon);
